import React, { useEffect, useState, useContext } from "react";
import { ArcherContainer, ArcherElement } from "react-archer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import { FiLogOut } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { logIn } from "../../Redux/Action";
import { AuthContext } from "../../context/AuthContext";
import Select from "react-select";
import { setVehicleDepartment } from "../../Redux/Action/logisticsDashboard";
import MasterNavbar from "../../Components/MasterNavbar/MasterNavbar";

function useIsSmallScreen() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isSmallScreen;
}

const DashboardFlow = () => {
  const navigate = useNavigate();
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(false);
  const [selVehicleDepartment, setSelVehicleDepartment] = useState("");
  const [vehicleDepartmentList, setVehicleDepartmentList] = useState([]);
  const isSmallScreen = useIsSmallScreen();
  const [
    ListOfVehiclesPendingGateInwardsCounter,
    setListOfVehiclesPendingGateInwardsCounter,
  ] = useState(0);
  const [
    ListOfVehiclesPendingInspectionAfterGateInCounter,
    setListOfVehiclesPendingInspectionAfterGateInCounter,
  ] = useState(0);

  const [vehiclesToComeToReturnsCounter, setVehiclesToComeToReturnsCounter] =
    useState(0);

  const [
    vehiclesToComeToReturnsBackToInspectionCounter,
    setVehiclesToComeToReturnsBackToInspectionCounter,
  ] = useState(0);

  const [
    vehiclesExpectedInWorkshopCounter,
    setVehiclesExpectedInWorkshopCounter,
  ] = useState(0);

  const [vehiclesInWorkshopAndJobsOpen, setVehiclesInWorkshopAndJobsOpen] =
    useState(0);
  const [
    releaseVehiclesFromWorkshopCounter,
    setReleaseVehiclesFromWorkshopCounter,
  ] = useState(0);
  const [
    listOfTrucksReleasedFromWorkshopCounter,
    setListOfTrucksReleasedFromWorkshopCounter,
  ] = useState(0);

  const [
    listOfTrucksReadyForLoadingCounter,
    setListOfTrucksReadyForLoadingCounter,
  ] = useState(0);

  const [dispatchOfVehiclesCounter, setDispatchOfVehiclesCounter] = useState(0);
  const [gateOutwardsCounter, setGateOutwardsCounter] = useState(0);
  const [WeighBridgeCounter, setWeighBridgeCounter] = useState(0);
  let weighOutCounter = 0;

  const dispatch = useDispatch();
  const { setAuthUser } = useContext(AuthContext);

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer,
  );

  function logOut() {
    dispatch(logIn([]));
    dispatch(setVehicleDepartment(""));
    navigate("/");
    window.sessionStorage.setItem("auth-token", "");
    window.sessionStorage.setItem("session-token", "");
    setAuthUser(null);
  }

  // useEffect(() => {
  //   initialData();
  // }, []);

  useEffect(() => {
    if (VehicleDepartment !== "") {
      fetchDataBasedOnDepartment(VehicleDepartment);
    } else {
      initialData();
    }
  }, [VehicleDepartment]);

  const initialData = () => {
    setisloading(true);
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1225`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setVehicleDepartmentList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicle Details:", error);
      });

    Promise.all([
      axios.get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      }),
      axios.get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      }),
    ])
      .then(([res1228, res671]) => {
        const normalize = (val) =>
          String(val || "")
            .trim()
            .toUpperCase();

        // trucks to exclude from 1228
        const excludeTruckSet = new Set(
          res1228?.data
            ?.filter((item) => item?.SECONDWEIGHT === null)
            ?.map((item) => normalize(item?.TRUCKNO)),
        );
        console.log(excludeTruckSet.size);
        weighOutCounter = excludeTruckSet.size;

        // dispatched vehicles from 671
        let vehicles = res671?.data?.filter(
          (item) => item?.VEHICLESTATE === "DISPATCHED",
        );

        // FINAL exclusion using "VEHICLE REG NO"
        const finalVehicles = vehicles.filter(
          (item) => !excludeTruckSet.has(normalize(item?.["VEHICLE REG NO"])),
        );

        // setVehiclesList(finalVehicles);
        //  const filterGateOutwards = response?.data?.filter(
        //       (item) => item.VEHICLESTATE === "DISPATCHED"
        // );
        setGateOutwardsCounter(finalVehicles?.length);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching vehicle data:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filterListOfVehiclesPendingGateInwards = response?.data?.filter(
          (item) => item.VEHICLESTATE === "GATE OUT" && item.TRAILER === false,
        );
        const filterListOfVehiclesPendingInspectionAfterGateIn =
          response?.data?.filter((item) => item.VEHICLESTATE === "GATE IN");

        const filterVehiclesToComeToReturns = response?.data?.filter(
          (item) => item.VEHICLESTATE === "SENT FOR RETURNS",
        );

        const filterVehiclesToComeToReturnsBackToInspection =
          response?.data?.filter(
            (item) => item.VEHICLESTATE === "PROCEED TO SECURITY DEPARTMENT",
          );

        const filterVehiclesInWorkshopAndJobsOpen = response?.data?.filter(
          (item) => item.VEHICLESTATE === "JOB IN WORKSHOP",
        );

        const filterreleaseVehiclesFromWorkshop = response?.data?.filter(
          (item) => item.VEHICLESTATE === "JOB CLOSED",
        );

        const filterListOfTrucksReleasedFromWorkshop = response?.data?.filter(
          (item) => item.VEHICLESTATE === "RELEASED FROM WORKSHOP",
        );

        const filterListOfTrucksReadyForLoading = response?.data?.filter(
          (item) => item.VEHICLESTATE === "SENT TO LOAD",
        );

        // const filterDispatchOfVehicles = response?.data?.filter(
        //   (item) => item.VEHICLESTATE === "SEND TO DISPATCH"
        // );

        // const filterGateOutwards = response?.data?.filter(
        //   (item) => item.VEHICLESTATE === "DISPATCHED"
        // );

        const filterWeighBridge = response?.data?.filter(
          (item) => item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE",
        );

        setVehiclesInWorkshopAndJobsOpen(
          filterVehiclesInWorkshopAndJobsOpen.length,
        );

        setListOfVehiclesPendingGateInwardsCounter(
          filterListOfVehiclesPendingGateInwards.length,
        );
        setListOfVehiclesPendingInspectionAfterGateInCounter(
          filterListOfVehiclesPendingInspectionAfterGateIn.length,
        );

        setVehiclesToComeToReturnsCounter(filterVehiclesToComeToReturns.length);

        setVehiclesToComeToReturnsBackToInspectionCounter(
          filterVehiclesToComeToReturnsBackToInspection.length,
        );

        setReleaseVehiclesFromWorkshopCounter(
          filterreleaseVehiclesFromWorkshop.length,
        );

        setListOfTrucksReleasedFromWorkshopCounter(
          filterListOfTrucksReleasedFromWorkshop.length,
        );

        setListOfTrucksReadyForLoadingCounter(
          filterListOfTrucksReadyForLoading.length,
        );

        // setDispatchOfVehiclesCounter(filterDispatchOfVehicles.length);
        // setGateOutwardsCounter(filterGateOutwards.length);
        setWeighBridgeCounter(filterWeighBridge.length + weighOutCounter);

        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicle Details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1319`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filterVehiclesExpectedInWorkshop = response?.data?.filter(
          (item) =>
            item.VEHICLESTATE === "SENT TO WORKSHOP" ||
            item.VEHICLESTATE === "JOB IN WORKSHOP",
        );
        setVehiclesExpectedInWorkshopCounter(
          filterVehiclesExpectedInWorkshop.length,
        );
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicle Details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1333`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const uniqueVehicles = [
          ...new Set(
            response?.data
              .map((item) => item?.["VEHICLE REG NO"])
              .filter(Boolean), // removes null / undefined / empty
          ),
        ];
        setDispatchOfVehiclesCounter(uniqueVehicles?.length);
        // setDispatchOfVehiclesCounter(response?.data?.length);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicle Details:", error);
      });
  };

  function fetchDataBasedOnDepartment(department) {
    setisloading(true);
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1225`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setVehicleDepartmentList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicle Details:", error);
      });

    Promise.all([
      axios.get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      }),
      axios.get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      }),
    ])
      .then(([res1228, res671]) => {
        const normalize = (val) =>
          String(val || "")
            .trim()
            .toUpperCase();

        // trucks to exclude from 1228
        const excludeTruckSet = new Set(
          res1228?.data
            ?.filter((item) => item?.SECONDWEIGHT === null)
            ?.map((item) => normalize(item?.TRUCKNO)),
        );
        weighOutCounter = excludeTruckSet.size;

        // dispatched vehicles from 671
        let vehicles = res671?.data?.filter(
          (item) => item?.VEHICLESTATE === "DISPATCHED",
        );

        // department filter
        if (department !== "") {
          vehicles = vehicles.filter((item) => item?.DEPARTMENT === department);
        }

        // FINAL exclusion using "VEHICLE REG NO"
        const finalVehicles = vehicles.filter(
          (item) => !excludeTruckSet.has(normalize(item?.["VEHICLE REG NO"])),
        );

        // setVehiclesList(finalVehicles);

        setGateOutwardsCounter(finalVehicles?.length);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching vehicle data:", error);
      });

    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=671&DEPARTMENT=${department}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      )
      .then((response) => {
        const filterListOfVehiclesPendingGateInwards = response?.data?.filter(
          (item) => item.VEHICLESTATE === "GATE OUT" && item.TRAILER === false,
        );
        const filterListOfVehiclesPendingInspectionAfterGateIn =
          response?.data?.filter((item) => item.VEHICLESTATE === "GATE IN");

        const filterVehiclesToComeToReturns = response?.data?.filter(
          (item) => item.VEHICLESTATE === "SENT FOR RETURNS",
        );

        const filterVehiclesToComeToReturnsBackToInspection =
          response?.data?.filter(
            (item) => item.VEHICLESTATE === "PROCEED TO SECURITY DEPARTMENT",
          );

        const filterVehiclesInWorkshopAndJobsOpen = response?.data?.filter(
          (item) => item.VEHICLESTATE === "JOB IN WORKSHOP",
        );

        const filterreleaseVehiclesFromWorkshop = response?.data?.filter(
          (item) => item.VEHICLESTATE === "JOB CLOSED",
        );

        const filterListOfTrucksReleasedFromWorkshop = response?.data?.filter(
          (item) => item.VEHICLESTATE === "RELEASED FROM WORKSHOP",
        );

        const filterListOfTrucksReadyForLoading = response?.data?.filter(
          (item) => item.VEHICLESTATE === "SENT TO LOAD",
        );

        // const filterDispatchOfVehicles = response?.data?.filter(
        //   (item) => item.VEHICLESTATE === "SEND TO DISPATCH"
        // );

        // const filterGateOutwards = response?.data?.filter(
        //   (item) => item.VEHICLESTATE === "DISPATCHED"
        // );

        const filterWeighBridge = response?.data?.filter(
          (item) => item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE",
        );

        setVehiclesInWorkshopAndJobsOpen(
          filterVehiclesInWorkshopAndJobsOpen.length,
        );

        setListOfVehiclesPendingGateInwardsCounter(
          filterListOfVehiclesPendingGateInwards.length,
        );
        setListOfVehiclesPendingInspectionAfterGateInCounter(
          filterListOfVehiclesPendingInspectionAfterGateIn.length,
        );

        setVehiclesToComeToReturnsCounter(filterVehiclesToComeToReturns.length);

        setVehiclesToComeToReturnsBackToInspectionCounter(
          filterVehiclesToComeToReturnsBackToInspection.length,
        );

        setReleaseVehiclesFromWorkshopCounter(
          filterreleaseVehiclesFromWorkshop.length,
        );

        setListOfTrucksReleasedFromWorkshopCounter(
          filterListOfTrucksReleasedFromWorkshop.length,
        );

        setListOfTrucksReadyForLoadingCounter(
          filterListOfTrucksReadyForLoading.length,
        );

        // setDispatchOfVehiclesCounter(filterDispatchOfVehicles.length);
        // setGateOutwardsCounter(filterGateOutwards.length);
        setWeighBridgeCounter(filterWeighBridge.length);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicle Details:", error);
      });

    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1319&DEPARTMENT=${department}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      )
      .then((response) => {
        const filterVehiclesExpectedInWorkshop = response?.data?.filter(
          (item) =>
            item.VEHICLESTATE === "SENT TO WORKSHOP" ||
            item.VEHICLESTATE === "JOB IN WORKSHOP",
        );
        setVehiclesExpectedInWorkshopCounter(
          filterVehiclesExpectedInWorkshop.length,
        );
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicle Details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1333`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const uniqueVehicles = [
          ...new Set(
            response?.data
              .map((item) => item?.["VEHICLE REG NO"])
              .filter(Boolean), // removes null / undefined / empty
          ),
        ];
        setDispatchOfVehiclesCounter(uniqueVehicles?.length);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicle Details:", error);
      });
  }

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <MasterNavbar />
      <div className="flex justify-center m-2">
        <p className="lg:ml-2 font-bold text-lg">Vehicle Department :</p>
        <Select
          className="lg:w-64 w-64 lg:ml-2"
          value={
            VehicleDepartment
              ? { value: VehicleDepartment, label: VehicleDepartment }
              : { value: "", label: "Select Vehicle Department" }
          }
          onChange={(e) => {
            // if (e.value !== "") {
            // fetchDataBasedOnDepartment(e.value);
            //   setSelVehicleDepartment(e.value);
            // } else {
            //   setSelVehicleDepartment(e.value);
            //   initialData();
            // }
            dispatch(setVehicleDepartment(e.value));
          }}
          options={[
            { value: "", label: "Select Vehicle Department" },
            ...vehicleDepartmentList?.map((item) => ({
              value: item.OM_VEHICLE_DEPARTMENT,
              label: item.OM_VEHICLE_DEPARTMENT,
            })),
          ]}
        ></Select>
      </div>

      <div className="grid lg:grid-cols-3 grid-cols-1 gap-8 mt-5 lg:ml-20 ml-10 justify-center items-center">
        <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/ListOfVehiclesPendingGateInwards");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {ListOfVehiclesPendingGateInwardsCounter}
          </div>

          <h3>List of Vehicles pending Gate Inwards and Verification</h3>
        </div>
        {/* <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/VehiclesPendingInspectionAfterGateIn");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {ListOfVehiclesPendingInspectionAfterGateInCounter}
          </div>
          <h3>Vehicles pending Inspection After Gate in</h3>
        </div> */}
        <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/RETURNSFROMCUSTOMER");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {vehiclesToComeToReturnsCounter}
          </div>
          <h3>Vehicles Under Returns</h3>
        </div>

        {/* <div
          className="w-[300px] relative h-[150px] rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/VehiclesInWorkshopAndJobsOpen");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {vehiclesInWorkshopAndJobsOpen}
          </div>
          <h3>Vehicles in Workshop and Jobs Open</h3>
        </div> */}
        <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/VehiclesInWorkshopAndJobsOpen");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {vehiclesExpectedInWorkshopCounter}
          </div>
          {/* <h3>Vehicles in Workshop</h3> */}
          <h3>Vehicles in Garage/Parking/Fueling/Washing</h3>
        </div>
        {/* <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/VehiclesFromReturnsBackToInspection");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {vehiclesToComeToReturnsBackToInspectionCounter}
          </div>
          <h3>Vehicles from Returns Back To Inspection</h3>
        </div> */}

        <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/WeighBridge");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {WeighBridgeCounter}
          </div>
          <h3>Vehicles in Weighbridges</h3>
        </div>

        <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/LOADINGORDERS");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {listOfTrucksReadyForLoadingCounter}
          </div>
          <h3>List of Trucks ready for Loading</h3>
        </div>
        <div
          className="w-[300px] h-[150px] relative rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/DISPATCHOFVEHICLES");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {dispatchOfVehiclesCounter}
          </div>
          <h3>Dispatch of Vehicles</h3>
        </div>
        <div
          className="w-[300px] relative h-[150px] rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/GateOutwards");
          }}
        >
          <div className="absolute w-9 h-9 top-2 right-2 bg-red-600 text-white text-xs font-bold flex items-center justify-center rounded-full shadow">
            {gateOutwardsCounter}
          </div>
          <h3>Gate Outwards</h3>
        </div>
        <div
          className="w-[300px] relative h-[150px] rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/VEHICLESANDTHEIRCURRENTSTATUS");
          }}
        >
          <h3>Vehicles and their Current Status</h3>
        </div>

         <div
          className="w-[300px] relative h-[150px] rounded-[20px] flex justify-center items-center text-center shadow-[0_5px_15px_rgba(0,0,0,0.35)] cursor-pointer transition-all duration-500 ease-in-out font-semibold text-[rgb(6,6,45)] text-lg hover:shadow-[0_5px_15px_rgba(5,14,59,0.35)] hover:scale-[1.07]"
          onClick={() => {
            navigate("/Reports");
          }}
        >
          <h3>Reports</h3>
        </div>
      </div>
    </div>
  );
};

export default DashboardFlow;
